module.exports = __webpack_public_path__ + "static/media/grand_mum_friend_eye_blink_02.1de37a2d.png";